import { useEffect } from "react";

export default function HotelSearchBox() {
  useEffect(() => {
    const wrapper = document.getElementById("adivaha-wrapper");
    if (!wrapper) return;

    // Prevent duplicate script load
    if (wrapper.querySelector("script")) return;

    const script = document.createElement("script");
    script.src = "https://www.abengines.com/ui/V2/77A93581/combo/";
    script.async = true;
    script.charset = "utf-8";

    // Delay injection slightly (IMPORTANT)
    setTimeout(() => {
      wrapper.appendChild(script);
    }, 300);

    return () => {
      wrapper.innerHTML = "";
    };
  }, []);

  return <div id="adivaha-wrapper" />;
}
